import { buildError } from './errors';
import { typeMap as errorTypeMap } from './errors/type-map';
import getActionForbiddenTemplate from './templates/action-forbidden';
import getConversionMolToSmilesErrorTemplate from './templates/conversion-mol-to-smiles-error';
import getConversionSmilesToMolErrorTemplate from './templates/conversion-smiles-to-mol-error';
import getCopyingToClipboardForbiddenTemplate from './templates/copying-to-clipboard-forbidden';
import getInternalErrorTemplate from './templates/internal-error';
import notAuthenticatedErrorTemplate from './templates/not-authenticated';
import getNotFoundTemplate from './templates/not-found';

const errorComponentTemplateMap = {
  [errorTypeMap.common.notFound]: getNotFoundTemplate,
  [errorTypeMap.common.actionForbidden]: getActionForbiddenTemplate,
  [errorTypeMap.common.copyingToClipboardForbidden]: getCopyingToClipboardForbiddenTemplate,
  [errorTypeMap.conversion.smilesToMol]: getConversionSmilesToMolErrorTemplate,
  [errorTypeMap.conversion.molToSmiles]: getConversionMolToSmilesErrorTemplate,
};

export function describeError(error, options = {}) {
  if (!error) {
    return null;
  }
  if (error.code === 401) {
    error.data = {
      type: 'not-authenticated',
      payload: notAuthenticatedErrorTemplate(),
    };
    return error;
  }

  const { data = {} } = error;
  const { type, payload } = data;

  const clonedError = buildError(type, payload);

  const getTemplate = errorComponentTemplateMap[type] || getInternalErrorTemplate;
  const template = getTemplate(clonedError, options);

  const { customTemplates = {} } = options;
  const customTemplate = customTemplates[type] || {};

  Object.assign(clonedError.data.payload, template, customTemplate);
  return clonedError;
}
